import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TooltipModule } from 'primeng/tooltip';

import { AccountRoutingModule } from './AccountRouter/account-routing.module';
import { UserPreferencesModule } from './UserPreferences/user-preferences.module';
import { DataConnectorComponent  } from './components/DataConnector/data-connector.component';
import { CommonFormsModule } from '../Common/Forms/forms.module';
import { LocalizationModule } from '../Core/Localization/localization.module';
import { NewDataConnectionDialogComponent } from './components/NewDataConnectionDialog/new-data-connection-dialog.component';
import { CoreDialogsModule } from '../Core/Dialogs/dialogs.module';
import { MiscModule } from '../Common/Misc/misc.module';
import { AccountPreferencesModule } from './AccountPreferences/account-preferences.module';
import { FileDownloadsComponent } from './components/FileDownloads/file-downloads.component';
import { CommonBasicModule } from '../Common/Basic/basic.module';
import { LayoutModule } from '../Common/Layout/layout.module';
import { SsoManagementComponent } from './components/SsoManagement/sso-management.component';
import { TakeOverModule } from '../Common/TakeOver/take-over.module';
import { EmailAccountConnectorComponent } from './components/EmailAccountConnector/email-account-connector.component';
import { BrandIdentityModule } from '../Common/BrandIdentity/brand-identity.module';

@NgModule({
    declarations: [
        DataConnectorComponent,
        NewDataConnectionDialogComponent,
        FileDownloadsComponent,
        SsoManagementComponent,
        EmailAccountConnectorComponent,
    ],
    imports: [
        UserPreferencesModule,
        AccountPreferencesModule,
        AccountRoutingModule,
        CommonFormsModule,
        CommonModule,
        LocalizationModule,
        FormsModule,
        CoreDialogsModule,
        MiscModule,
        TooltipModule,
        CommonBasicModule,
        LayoutModule,
        TakeOverModule,
        BrandIdentityModule
    ],
    exports: [
        DataConnectorComponent,
        SsoManagementComponent,
        EmailAccountConnectorComponent,
    ]
})
export class AccountModule { }
